import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 11h14v2H5zm-2 4h14v2H3zm4-8h14v2H7z"
}), 'ClearAllTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ClearAllTwoTone.js
// module id = 2813
// module chunks = 2